/**
 * Created by Christof Sander on 27.09.2016.
 */

const utils = require('frontend-controller/lib/utils')

module.exports = {
	extends: [
		'/',
		'base',
		'treesManagement',
		'trees'
	],

	config: {
		mode: "",
		treeTypeComponents: {
			default: [
				'/',
				'templates',
				'tagScopeTrees',
				'tagScopeTree'
			]
		}
	},

	methods: {
		// operations
		insert: function(baseActionKey, buttonContext, buttonMode, actionBossComponent){
			if(this.actions[baseActionKey]){
				this.deselectActiveNode();

				if(buttonContext === 'tagScope'){
					return this.performAction(this.prepareAction(baseActionKey));
				}
			}

			return utils.promise.reject();
		},

		duplicate: function(baseActionKey, buttonContext, buttonMode, actionBossComponent){
			var self        = this;
			var nodeData    = self.getSelectedNodeData();
			var dirtyData   = {};

			if(self.actions[baseActionKey] && nodeData._primaryKey){

				return self.performAction(
					self.prepareAction(baseActionKey, nodeData._primaryKey, undefined, {
						source: {
							submit: {
								data: dirtyData
							}
						}
					})
				).then(function(context) {
					self.config.readyNodeID = context.response.data.attributes[context.response.data.primaryKey];
					self.config.readyNodeContext = buttonContext;
					self.refreshTrees();

					return utils.promise.resolve(context);
				});
			}

			return utils.promise.reject();
		},

		delete: function(baseActionKey, buttonContext, buttonMode, actionBossComponent){
			var self = this;

			return self.performDecision(
				'confirm',
				{
					component:  self,
					title:      storage.__('hint.delete.really.' + buttonContext + '.title'),
					message:    storage.__('hint.delete.really.' + buttonContext + '.message')
				}
			).then(function(context) {
				if (context.decision.type === 'yes') {
					var nodeData = self.getSelectedNodeData();
					var nodeIndex = self.getSelectedNodeIndex();
					var nodeContext = self.getNodeContext(nodeIndex);
					var nodeID = self.getSelectedNodeID();
					self.deselectActiveNode();
					if(nodeID != undefined && self.actions[baseActionKey]){
						var performActions = [];

						self.setClosestNodeAsReady(nodeIndex);

						if(buttonContext === 'tagScope'){
							performActions.push(self.performAction(
								self.prepareAction(baseActionKey, nodeID)
							));
						}

						return utils.promise.performAll(self, performActions).then(function(context){
							self.refreshTrees();
							return context;
						});
					}
				}

				return utils.promise.reject();
			});
		},

		sanitizeResources: function(){
			var self = this;
			var resources = {
				initialized: false,
				trees: [
					{
						name: 'TagScopes...',
						tree: [],
						nodes: {}
					}
				]
			};
			var tree = resources.trees[0].tree;
			var nodes = resources.trees[0].nodes;
			var contextIcon;

			if(this.resourceData.data && !this.resourceData.initialized) {
				this.resetNodeMappings();
				this.config.extendedTreeView = this.hasRoleOption('extendedTreeView');
				resources.initialized = true;

				// prevent parent order problems
				var elements = {};
				var tagScopeCounter = 0;
				utils.forEach(this.resourceData.data, function (tagScope) {
					elements[self.transformIDToIndex(tagScope.attributes[tagScope.primaryKey], 'tagScope', 0, tagScopeCounter)] = tagScope;
					tagScopeCounter++;
				});

				// insert categories
				utils.forEach(elements, function (tagScope, tagScopeIndex) {

					var primaryKey  = tagScope.attributes[tagScope.primaryKey];
					contextIcon     = undefined;
					var parent      = '#';
					tree.push({
						id: tagScopeIndex,
						parent: parent,
						text: tagScope.attributes.code + (self.config.extendedTreeView ? ' [' + primaryKey + ']' : ''),
						type: 'tagScope',
						icon: contextIcon,
						state: {
							opened: false,
							disabled: false,
							selected: false
						},
						li_attr: {},
						a_attr: {}
					});
					nodes[tagScopeIndex] = tagScope.attributes;
					nodes[tagScopeIndex]._primaryKey = primaryKey;
				});

				this.resourceData = resources;
			}
		},

		/**
		 * support multiple action forms.
		 *
		 * @param data      {} - onTreeAction trigger context
		 */
		onTreeAction: function (data) {
			var actionFormsSelector = '.base_treesManagement_actionsForm';

			switch (data.onTreeActionOptions.eventType) {
				case 'select_node.jstree':
					// show page actions if necessary
					this.$.find(actionFormsSelector).hide();
					var selector = '.tagScopeTreesActions';
					this.$.find(selector).show();
					break;

				case 'deselect_node.jstree':
					// hide page actions if necessary
					this.$.find(actionFormsSelector).hide();
					break;
			}
		},

		onAttachDone: function(){
			var subActionsHtml;
			// NOTE:    trees does not contain subActions necessarily.
			//          therefor the potential error (subActions not found) will be ignored.
			try {
				subActionsHtml = this.include('subActions');
				var $parent = this.$.find('section.actions');
				if($parent.length <= 0) $parent = this.$;
				$parent.append(subActionsHtml);
			} catch(error){}
		}
	},

	handlers: [
		{
			name: 'afterCancel',
			componentClass: 'templates_propertiesForms_tagScopePropertiesForm',
			handle: function(callerComponent){
				this.deselectActiveNode();
			}
		},
		{
			name: 'onSubmitDone',
			componentClass: 'templates_propertiesForms_tagScopePropertiesForm',
			handle: function(callerComponent, nodeData, insertPerformed){
				if(insertPerformed){
					this.config.readyNodeID       = nodeData.data.attributes[nodeData.data.primaryKey];
					this.config.readyNodeContext  = 'tagScope';
					callerComponent.destroy();
				}
				this.refreshTrees();
			}
		}
	]
};
